import styled from 'styled-components';

export const useAlert = () => {
    function handleAlert(code: number, title: string, error: string) {
        const alertsContainer = document.querySelector('.alerts-container');
        const alert = document.createElement('div');
      
        // Verify if alert already exist
        const alertsList = Array.from(document.querySelectorAll('.status-alert'));
        const alreadyExist = alertsList.find(alertItem => alertItem.id === `code-${code}`);
        if (alreadyExist) return;
      
        alert.className = 'status-alert';
        alert.classList.add(
            code.toString()[0] === '2' 
            ? 'success' 
            : code.toString()[0] === '4' 
                ? 'error'
                : 'warning'
        );
        
        alert.id = 'code-' + code;
        alert.innerHTML = `
          <i class="fal fa-times"></i>
      
          <div class="text">
            <strong>${title}</strong>
            <span>${error}</span>
          </div>
        `;
        alert.style.animation = 'enterAnimation .5s ease-in-out forwards';
      
        alertsContainer?.appendChild(alert);
        document.querySelector(`#code-${code} i`)?.addEventListener('click', remove);
      
        function remove() {
          alert.style.animation = 'outAnimation .5s ease-in-out forwards';
      
          setTimeout(() => {
            alert.remove();
          }, 500);
        }
      
        setTimeout(remove, 10000);
    }

    const Alerts = () => <AlertsContainer className="alerts-container" />;

    return { 
        handleAlert,
        Alerts
    }
}

const AlertsContainer = styled.div`
    position: fixed;
    top: 10rem;
    right: 5rem;
    z-index: 1000;

    pointer-events: none;

    .status-alert {
        position: relative;
        display: flex;

        height: auto;
        width: 25rem;
        padding: 1rem;
        padding-left: 2rem;
        margin-bottom: 2rem;

        background: #fff;
        border: 1px solid rgba(0, 0, 0, .1);
        border-radius: 1rem;
        box-shadow: 1rem 1rem 3rem rgba(0, 0, 0, .1);
        pointer-events: auto;

        opacity: 0;

        &.error {
            border-left: 5px solid var(--color-error);
        }

        &.warning {
            border-left: 5px solid var(--color-warning);
        }

        &.success {
            border-left: 5px solid var(--color-success);
        }

        i {
            position: absolute;
            top: 1.4rem;
            right: 1.8rem;

            display: flex;
            align-items: center;
            justify-content: center;

            width: 1rem;
            height: 1rem;

            font-size: 1.3rem;
            color: rgba(0, 0, 0, .3);

            cursor: pointer;

            &:hover {
                color: #000;
            }
        }

        .text {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;

            strong {
                font-size: 1.3rem;
                margin-bottom: .5rem;
                color: #000;
            }

            span {
                font-size: 1.2rem;
            }
        }
    }

    @keyframes enterAnimation {
        0% {
            opacity: 0;
            transform: translateX(150%);
        }

        80% {
            opacity: 1;
        }

        90% {
            transform: translateX(-2%);
        }

        100% {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @keyframes outAnimation {
        0% {
            opacity: 1;
            max-height: 7.9rem;
            pointer-events: none;
        }

        10% {
            opacity: 0;
        }

        100% {
            opacity: 0;
            max-height: 0;
            margin-bottom: 0;
            padding: 0;
        }
    }

    @media (max-width: 540px) {
        top: 13.88889vw;
        right: 5%;

        .status-message {
            width: 64vw;
            padding: 1.94444vw;
            padding-left: 2.77778vw;
            margin-bottom: 4.16667vw;

            i {
                right: 1.94167vw;
                width: 2.77778vw;
                height: 2.77778vw;
                font-size: 2.77778vw;
            }

            .text {
                strong {
                    font-size: 3.07778vw;
                    margin-bottom: 0.55556vw;
                }

                span {
                    font-size: 2.52222vw;
                }
            }
        }
    }
`;